<template>
  <div>
    <ShiftForm  v-show="!managingBreaks" @clearOriginalEditingShift="editingShift = null" :originalEditingShift="editingShift"></ShiftForm>
    <BreaksForm @editBreaksDismissed="managingBreaks = null" v-if="managingBreaks" :shift="managingBreaks"></BreaksForm>
    <ShiftsOverview @manageBreaks="managingBreaks === $event ? managingBreaks = null : managingBreaks = $event" @editShift="editingShift = $event; managingBreaks = null"></ShiftsOverview>
  </div>
</template>

<script>
import ShiftForm from "@/components/shifts/ShiftForm";
import ShiftsOverview from "@/components/shifts/ShiftsOverview";
import BreaksForm from "@/components/shifts/BreaksForm.vue";

export default {
  name: "Shifts",
  components: {BreaksForm, ShiftsOverview, ShiftForm},
  data() {
    return {
      editingShift: null,
      managingBreaks: null
    }
  },
  computed: {

  }
}
</script>

<style scoped>

</style>